/**
 * Created by Claude on 30.01.2026
 */

const LightningRushGardenContent = cc.Node.extend({
    ctor: function (controller, { closeWindowCallback }) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(cleverapps.resolution.getSceneSize());

        const styles = cleverapps.styles.LightningRushGardenContent;

        this.controller = controller;
        this.closeWindowCallback = closeWindowCallback;

        // Create a content container with fixed size
        this.content = new cc.Node();
        this.content.setAnchorPoint(0.5, 0.5);
        this.content.setContentSize2(styles.size);
        this.addChild(this.content);
        this.content.setPosition(this.width / 2, this.height / 2 - 50);

        this.createBg();
        this.createImage();
        this.createTitle();
        this.createInfoButton();
        this.createTimer();
        this.createTable();
        this.createFooter();

        // Add close button to the screen, not the content container
        this.createCloseButton();
    },

    createBg: function () {
        const styles = cleverapps.styles.LightningRushGardenContent;

        const bg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.bg_png);
        bg.setContentSize2(styles.size);
        this.content.addChild(bg);
        bg.setAlignment(styles.bg);

        const leftEar = new cc.Sprite(bundles.lightning_rush_frame.frames.decor_ear_png);
        bg.addChild(leftEar, -1);
        leftEar.setScaleX(-1);
        leftEar.setAlignment(styles.bg.leftEar);

        const rightEar = new cc.Sprite(bundles.lightning_rush_frame.frames.decor_ear_png);
        bg.addChild(rightEar, -1);
        rightEar.setAlignment(styles.bg.rightEar);
    },

    createImage: function () {
        const styles = cleverapps.styles.LightningRushGardenContent;
        const image = new cc.Sprite(bundles.lightning_rush_window.frames.picture_png);
        this.content.addChild(image);
        image.setAlignment(styles.image);
    },

    createTitle: function () {
        const styles = cleverapps.styles.LightningRushGardenContent;

        const titleBg = this.titleBg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.half_title_png);
        titleBg.setContentSize2(styles.title.bg.width, titleBg.height);
        this.content.addChild(titleBg);
        titleBg.setAlignment(styles.title.bg);

        const title = cleverapps.UI.generateOnlyText(Messages.get("Missions.LightningRush.Title"), cleverapps.styles.FONTS.LIGHTNING_RUSH_GARDEN_TITLE_TEXT);
        this.content.addChild(title);
        title.setAlignment(styles.title);
        title.fitTo(styles.title.width);
    },

    createInfoButton: function () {
        const helpButton = this.infoButton = new cleverapps.UI.HelpButton({
            type: {
                button_png: bundles.lightning_rush_window.frames.help_button_png,
                button_on_png: bundles.lightning_rush_window.frames.help_button_on_png
            },
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.controller.getMission());
                cleverapps.tutorial.trigger("infoClicked");
            }
        });
        helpButton.setAnchorPoint(0.5, 0.5);
        this.content.addChild(helpButton);
        helpButton.setAlignment(cleverapps.styles.LightningRushGardenContent.infoButton);
    },

    createCloseButton: function () {
        const closeButton = this.closeButton = new CloseRoundButton({
            onClicked: this.closeWindowCallback
        });
        this.addChild(closeButton);
        closeButton.setAlignment(cleverapps.styles.LightningRushGardenContent.closeButton);
    },

    createTimer: function () {
        const styles = cleverapps.styles.LightningRushGardenContent.timer;

        const bg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.substrate_png);
        bg.setContentSize2(styles.bg.width, bg.height);
        this.content.addChild(bg);
        bg.setAlignment(styles.bg);

        let text;
        if (this.controller.getMission().logic.isActiveState()) {
            let timeLeft = this.controller.getTimeLeft();
            if (timeLeft > 0) {
                timeLeft = new cleverapps.CountDown(timeLeft, {
                    onFinish: this.closeWindowCallback
                });
            }

            text = new cleverapps.CountDownView(timeLeft, {
                font: cleverapps.styles.FONTS.LIGHTNING_RUSH_GARDEN_TIMER_TEXT,
                showHours: false
            });
        } else {
            text = cleverapps.UI.generateOnlyText(Messages.get("Missions.windowFinished"), cleverapps.styles.FONTS.LIGHTNING_RUSH_GARDEN_TIMER_TEXT);
            text.fitTo(styles.width, styles.height);
        }

        const icon = this.icon = new cc.Sprite(bundles.timer.frames.timer_png);
        icon.setScale(0.9);

        const layout = new cleverapps.Layout([icon, text], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        bg.addChild(layout);
        layout.setAlignment(styles);
    },

    createFooter: function () {
        const styles = cleverapps.styles.LightningRushGardenContent.footer;
        const footer = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.footer_png);
        footer.setContentSize2(styles.width, footer.height);
        this.content.addChild(footer);
        footer.setAlignment(styles);

        const bell = new cc.Scale9Sprite(bundles.lightning_rush_window.frames.bell_png);
        footer.addChild(bell);
        bell.setAlignment(styles.bell);
    },

    createTable: function () {
        const styles = cleverapps.styles.LightningRushGardenContent.table;
        const controller = this.controller;

        const table = controller.getTable();
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: false,
            dock: { toEnd: false },
            mouseScroll: false,
            touchScroll: false
        });

        new TableHandler(table, tableView, {
            id: controller.getType(),
            height: styles.height,
            rowConstructor: LightningRushGardenRowView,
            rowOptions: {
                width: styles.width,
                height: styles.rowHeight,
                dataIcon: bundles.tablerow_icons.frames.lighting_rush_tablerow_icon,
                mission: controller.getMission()
            },
            styles: cleverapps.styles.LightningRushGardenContent.tableStyles
        });

        tableView.setAnchorPoint(0.5, 0.5);
        this.content.addChild(tableView);
        tableView.setAlignment(styles);
    },

    onResize: function () {
        this.setContentSize(cleverapps.resolution.getSceneSize());
        if (this.content) {
            this.content.setPosition(this.width / 2, this.height / 2 - 50);
        }
        if (this.closeButton) {
            this.closeButton.setAlignment(cleverapps.styles.LightningRushGardenContent.closeButton);
        }
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    LIGHTNING_RUSH_WINDOW_TITLE_COLOR: new cc.Color(20, 20, 145, 255)
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    LIGHTNING_RUSH_WINDOW_TITLE_STROKE: {
        size: 3,
        color: cleverapps.styles.COLORS.LIGHTNING_RUSH_WINDOW_TITLE_COLOR
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LIGHTNING_RUSH_GARDEN_TITLE_TEXT: {
        size: 55,
        stroke: cleverapps.styles.DECORATORS.LIGHTNING_RUSH_WINDOW_TITLE_STROKE,
        color: cleverapps.styles.COLORS.WHITE
    },

    LIGHTNING_RUSH_GARDEN_TIMER_TEXT: {
        name: "default",
        size: 36,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.LightningRushGardenContent = {
    size: {
        width: 660,
        height: 1000
    },

    bg: {
        x: { align: "center" },
        y: { align: "center" },

        leftEar: {
            x: { align: "left", dx: 0 },
            y: { align: "top", dy: 180 }
        },
        rightEar: {
            x: { align: "right", dx: 0 },
            y: { align: "top", dy: 180 }
        }
    },

    infoButton: {
        x: { align: "left", dx: 30 },
        y: { align: "top", dy: 64 }
    },

    closeButton: {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -20 }
    },

    timer: {
        width: 150,
        height: 60,

        margin: 10,
        x: { align: "center", dx: -15 },
        y: { align: "center", dy: 10 },

        icon: {
            x: { align: "center", dx: -80 },
            y: { align: "center", dy: 10 }
        },
        bg: {
            width: 705,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 80 }
        }
    },

    tableStyles: {
        size: {
            width: 500,
            height: 500
        },

        margin: 3,
        padding: { x: 6, y: 2 },
        innerPadding: { x: 6, y: 0 },

        pinnedDy: 0,

        barPadding: {
            cornerPadding: 20,
            sidePadding: 5
        }
    },
    table: {
        margin: -2,
        x: { align: "center" },
        y: { align: "bottom", dy: 35 },
        width: 630,
        height: 510,
        rowHeight: 100
    },

    image: {
        x: { align: "center" },
        y: { align: "center", dy: 303 }
    },

    title: {
        bg: {
            width: 800,
            x: { align: "center" },
            y: { align: "top", dy: 103 }
        },

        x: { align: "center" },
        y: { align: "top", dy: 74 },
        width: 400
    },

    footer: {
        width: 705,
        x: { align: "center" },
        y: { align: "bottom", dy: -17 },

        bell: {
            x: { align: "center" },
            y: { align: "center", dy: -36 }
        }
    },

    contentPadding: {
        top: 250
    }
};
